/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { matchPath } from 'react-router'
import autoBind from 'react-autobind'
import bindStateToProps from 'lib/bindStateToProps'
import bindActionCreators from 'lib/bindActionCreators'

// import components
import AppDetailView from 'components/organisms/AppDetailView'

import { actions as appstoreActions } from 'store/modules/appstore'

class AppDetailContainer extends Component {
  constructor(props) {
    super(props)
    autoBind(this)
  }

  componentDidMount() {
    const { AppstoreActions, location } = this.props
    const { params: { appId } = {} } =
      matchPath(location.pathname, {
        path: '/apps/:appId',
        exact: true,
        strict: false
      }) || {}
    AppstoreActions.getAppData(appId)
  }

  onClickContentImg(selectedDetailImg) {
    this.setState({ selectedDetailImg })
  }

  getProps(props) {
    return Object.assign(
      {},
      ...props.map(prop => {
        return { [prop]: this[prop] }
      })
    )
  }

  render() {
    const thisProps = `
      onClickContentImg
    `
      .replace(/\n|\s/g, ',')
      .split(',')
    const props = Object.assign(
      {},
      this.props,
      this.state,
      this.getProps(thisProps.filter(d => d))
    )
    return <AppDetailView {...props} />
  }
}

export default withRouter(
  connect(
    bindStateToProps({
      appstore: ['appData', 'appListLoading'],
      pricing: [
        {
          pricing: 'responseData.getDefaultMessagePriceList'
        }
      ]
    }),
    bindActionCreators({
      appstoreActions
    })
  )(AppDetailContainer)
)
